{
  "#MDE_ETIKETTENDRUCK": {
    "STEPS": {
      "PREISART": {
        "TITLE": "Preisart-Auswahl",
        "DESCRIPTION": "Bitte Preisart auswählen!"
      },
      "ETIKETTENART": {
        "TITLE": "Etikettenart",
        "DESCRIPTION": "Bitte Etikettenart auswählen!"
      }
    },
    "DETAIL": {
      "SCAN_UPDATE_MENGE_TITLE": "Menge aktualisiert",
      "SCAN_UPDATE_MENGE_MESSAGE": "Die Menge wurde um 1 erhöht!",
      "SCAN_ADD_ARTIKEL_TITLE": "Artikel hinzugefügt",
      "SCAN_ADD_ARTIKEL_MESSAGE": "Der Artikel wurde erfolgreich hinzugefügt"
    }
  }
}
